// 겸직 소속(회사·부서) 순수 함수 — 프로필 메뉴(TopNav)가 쓴다. React·DOM 에 의존하지 않아 node 로 시험한다.

/** GET /api/basicinfo/me/affiliations 한 행 — 사원이 속한 회사의 유효 소속(주소속이 먼저) */
export interface Affiliation {
  comSq: number;
  comNm: string;
  deptCd: string;
  deptNm: string;
  mainYn: boolean;
}

export interface AffiliationGroup {
  comSq: number;
  comNm: string;
  items: Affiliation[];
}

/** 선택값(저장 형태) — 공용 키트의 ActiveAffiliation 과 같은 모양 */
export interface AffiliationPick {
  comSq: number;
  deptCd: string;
}

/** 응답 정규화 — 배열이 아니거나 필수 필드가 깨진 행은 버린다(SPA fallback 이 200 으로 올 수 있다) */
export function normalizeAffiliations(body: unknown): Affiliation[] {
  if (!Array.isArray(body)) return [];
  return body.filter((r): r is Affiliation =>
    !!r && Number.isInteger(r.comSq) && typeof r.deptCd === 'string' && r.deptCd !== ''
    && typeof r.comNm === 'string' && typeof r.deptNm === 'string');
}

/** 현재 소속 — 저장된 선택이 목록에 있으면 그것, 아니면 주소속(mainYn), 그것도 없으면 첫 행. 빈 목록이면 null */
export function resolveActive(list: Affiliation[], stored: AffiliationPick | null): Affiliation | null {
  if (list.length === 0) return null;
  if (stored) {
    const hit = list.find(a => a.comSq === stored.comSq && a.deptCd === stored.deptCd);
    if (hit) return hit;
  }
  return list.find(a => a.mainYn) || list[0];
}

/** 회사별 묶음 — 회사·부서 순서는 응답(주소속 먼저) 순서를 그대로 지킨다 */
export function groupByCompany(list: Affiliation[]): AffiliationGroup[] {
  const groups: AffiliationGroup[] = [];
  list.forEach(a => {
    let g = groups.find(x => x.comSq === a.comSq);
    if (!g) { g = { comSq: a.comSq, comNm: a.comNm, items: [] }; groups.push(g); }
    g.items.push(a);
  });
  return groups;
}

/** 표시 문구 「회사 - 부서」 */
export function affiliationLabel(a: Affiliation): string {
  return `${a.comNm} - ${a.deptNm}`;
}
